import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getCommunitySensors, selectCommunitySensor, setCommunitySensorsFilters } from '../store/actions/communitySensorsActions';
// import { getAllFields, getFields } from '../store/actions/fieldsActions';
import { filterUser } from "../store/actions/usersActions";
import {getStatusColor, isCompanyAdmin, isDistributorAdmin, isSuperAdmin} from '../helpers/helpers';
import './CommunitySensors.scss';

import Spinner from './_common/Spinner';
import List from './_common/List';
import SensorsMap from './SensorsMap';
import {getSensors, setSensorsFilters} from "../store/actions/sensorsActions";
import MapWithPopups from "./MapWithPopups";
// import SensorModal from './SensorModal';

const selector = state => {
    const { language, communitySensors, modalState, fields, users } = state;
    return {
        t: language.translator,
        pending: communitySensors.pending,
        communitySensors: communitySensors.communitySensors,
        page: communitySensors.page,
        pageCount: communitySensors.pageCount,
        itemsCount: communitySensors.itemsCount,
        selected: communitySensors.selected,
        filters: communitySensors.filters,
        modalState: modalState,
        fields: fields.fields,
        filteredUser: users.filtered,
    }
};

const CommunitySensors = () => {
    const { t, pending, communitySensors, page, pageCount, itemsCount, modalState, selected, filters, fields, filteredUser } = useSelector(selector);
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('ALL');
    // const [search, setSearch] = useState('');
    const [hideMap, setHideMap] = useState(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin());
    const [itemsPerPage, setItemsPerPage] = useState(hideMap ? 10 : 3);

    useEffect(() => {
        if(isCompanyAdmin() || isSuperAdmin()) {
            dispatch(filterUser({}));
            // dispatch(setCommunitySensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: ''}))
            // dispatch(getAllFields());
            dispatch(getCommunitySensors(1, itemsPerPage, filter, '', ''));
        } else {
            // dispatch(setCommunitySensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: ''}))
            // dispatch(getFields());
            dispatch(getCommunitySensors(1, itemsPerPage, filter, '', ''));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let communitySensorMarkers = [];

    if(communitySensors.length) {
        communitySensors.forEach(sensor => {
            if (sensor.lat && sensor.lon) {
                communitySensorMarkers.push(
                    {
                        lat: sensor?.lat,
                        lng: sensor?.lon,
                        color: getStatusColor(sensor?.temperatureStatus),
                        name: sensor.name,
                        // loraIdentifier: sensor?.loraIdentifier,
                        // temperature: sensor?.temperature,
                        // humidity: sensor.measurements.length ? sensor.measurements[0].humidity : '',
                        // date: sensor.measurements.length ? sensor.measurements[0].dateTimeCreated.replace('T') : '',
                        id: sensor.id
                    }
                )
            }
        });
    }

    return (
        <div className='communitySensors'>
            <div className={!hideMap ? 'sensorMap sensorMap--expanded' : 'sensorMap'}>
                <MapWithPopups
                    zoom={5.8}
                    center={{lat: 52.2297, lng: 21.0122}}
                    markers={communitySensorMarkers}
                    mapType={'sensors'}
                />
                {/*<SensorsMap*/}
                {/*    defaultZoom={5.8}*/}
                {/*    defaultCenter={{lat: 52.2297, lng: 21.0122}}*/}
                {/*    markers={communitySensorMarkers}*/}
                {/*/>*/}
                <div
                    className='hideMapButton'
                    onClick={() => {
                        dispatch(setCommunitySensorsFilters({active: filter, itemsPerPage, search: filters.search}))
                        dispatch(getCommunitySensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : '', filters.search));
                        setHideMap(!hideMap)
                    }}
                >
                    <span className='material-icons hideMapButtonIcon'>
                        {hideMap ? 'expand_more' : 'expand_less'}
                    </span>
                </div>
            </div>

            <form className='sensorFilter'>
            {/*    <input*/}
            {/*        type='radio'*/}
            {/*        id='filterActive'*/}
            {/*        checked={filter === 'ACTIVE'}*/}
            {/*        onChange={() => {*/}
            {/*            dispatch(setCommunitySensorsFilters({active: 'ACTIVE', itemsPerPage: hideMap ? 10 : 3, search: filters.search}));*/}
            {/*            setFilter('ACTIVE');*/}
            {/*            dispatch(getCommunitySensors(1, hideMap ? 10 : 3, 'ACTIVE', filteredUser.id ? filteredUser.id : '', filters.search));*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <label htmlFor='filterActive'>*/}
            {/*        {t.gettext('Active')}*/}
            {/*    </label>*/}
            {/*    <input*/}
            {/*        type='radio'*/}
            {/*        id='filterNotActive'*/}
            {/*        checked={filter === 'NOT_ACTIVE'}*/}
            {/*        onChange={() => {*/}
            {/*            dispatch(setCommunitySensorsFilters({active: 'NOT_ACTIVE', itemsPerPage: hideMap ? 10 : 3, search: filters.search}));*/}
            {/*            setFilter('NOT_ACTIVE');*/}
            {/*            dispatch(getCommunitySensors(1, hideMap ? 10 : 3, 'NOT_ACTIVE', filteredUser.id ? filteredUser.id : '', filters.search));*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <label htmlFor='filterNotActive'>*/}
            {/*        {t.gettext('Not Active')}*/}
            {/*    </label>*/}
            {/*    <input*/}
            {/*        type='radio'*/}
            {/*        id='filterAll'*/}
            {/*        checked={filter === 'ALL'}*/}
            {/*        onChange={() => {*/}
            {/*            dispatch(setCommunitySensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: filters.search}));*/}
            {/*            setFilter('ALL');*/}
            {/*            dispatch(getCommunitySensors(1, hideMap ? 10 : 3, 'ALL', filteredUser.id ? filteredUser.id : '', filters.search));*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <label htmlFor='filterAll'>*/}
            {/*        {t.gettext('All')}*/}
            {/*    </label>*/}

            {/*    <div className='searchInputWrapper'>*/}
            {/*        <input*/}
            {/*            type='text'*/}
            {/*            className='sensorSearchInput'*/}
            {/*            value={search}*/}
            {/*            onChange={e => setSearch(e.target.value)}*/}
            {/*        />*/}
            {/*        {filters.search*/}
            {/*            ? <span*/}
            {/*                className='material-icons sensorSearchCancelButton'*/}
            {/*                onClick={() => {*/}
            {/*                    dispatch(setCommunitySensorsFilters({active: filter, itemsPerPage: hideMap ? 10 : 3, search: ''}));*/}
            {/*                    setSearch('');*/}
            {/*                    dispatch(getCommunitySensors(1, hideMap ? 10 : 3, filter, filteredUser.id ? filteredUser.id : '', ''));*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                cancel*/}
            {/*            </span>*/}
            {/*            : null*/}
            {/*        }*/}
            {/*    </div>*/}
            {/*    <button*/}
            {/*        className='sensorSearchButton'*/}
            {/*        onClick={e => {*/}
            {/*            e.preventDefault();*/}
            {/*            setFilter('ALL');*/}
            {/*            dispatch(setCommunitySensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: search}))*/}
            {/*            dispatch(getCommunitySensors(1, hideMap ? 10 : 3, 'ALL', filteredUser.id ? filteredUser.id : '', search))*/}
            {/*        }}*/}
            {/*        disabled={!search}*/}
            {/*    >*/}
            {/*        {t.gettext('SEARCH')}*/}
            {/*    </button>*/}

                <label htmlFor='itemsPerPage' className={'itemsPerPageLabel'}>
                    {t.gettext('Items per page')}
                </label>
                <input
                    type='number'
                    id='itemsPerPage'
                    className='sensorSearchInput itemsPerPageInput'
                    min={1}
                    step={1}
                    defaultValue={itemsPerPage}
                    onChange={e => {
                        e.preventDefault();
                        if(e.target.value) {
                            setItemsPerPage(e.target.value < 1 ? 1 : e.target.value);
                            dispatch(setCommunitySensorsFilters({active: filter, itemsPerPage: e.target.value < 1 ? 1 : e.target.value, search: filters.search}));
                            dispatch(getCommunitySensors(1, e.target.value < 1 ? 1 : e.target.value, filter, filteredUser.id ? filteredUser.id : '', filters.search));
                        }
                    }}
                />
            </form>

            <div className={hideMap ? 'sensorList sensorList--expanded' : 'sensorList'}>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={communitySensors}
                        page={page}
                        itemsPerPage={itemsPerPage}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={['Lora Identifier', 'Sensor Name']}
                        columns={['realSensorLoraId', 'name']}
                        columnsWidths={['50%', '50%']}
                        filter={filter}
                        measurementTimeColumn={3}
                        booleanColumn={4}
                        getItemsMethod={getCommunitySensors}
                        selectItemMethod={selectCommunitySensor}
                        onSelectModalName='Sensor details'
                        userId={filteredUser.id ? filteredUser.id : ''}
                        search={filters.search}
                    />
                }

                {/*{(modalState.flag && modalState.modal === 'Sensor details') &&*/}
                {/*    <SensorModal*/}
                {/*        sensor={selected.sensor}*/}
                {/*        fields={fields}*/}
                {/*        numberPerPage={hideMap ? 10 : 3}*/}
                {/*        filter={filter}*/}
                {/*        userId={filteredUser.id ? filteredUser.id : ''}*/}
                {/*    />*/}
                {/*}*/}
            </div>
        </div>
    );
};

export default CommunitySensors;
